import React from "react";
import classes from "./ContentContainer.css";


const contentContainer = (props) => (
  <>
    <div className={classes.titleContainer}>
      <p className={classes.title}>{props.title}</p>
      <div className={classes.rightContainer}>
        {props.rightContainer}
      </div>
    </div>
    <div className={classes.container}>
      {props.children}
    </div>
  </>
);

export default contentContainer;
